import React, {Component} from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import 'moment-timezone';
import moment from "moment";

import ManifestEventForm from "./ManifestEventForm";
import JwtClient from "./JwtClient";
import Logout, {FormatManifestNumber} from "./utils";
import Alert from "./Alert";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import IBCCustomsClearanceForm from "./IBCCustomsClearanceForm";

function getAvailableDescriptions(existedEvents) {
    let used = [];
    let e;
    for (e of existedEvents) {
        used.push(e['description']);
    }
    const all = [
        'arrived at airport',
        'arrived at customs',
        'in process at customs',
        'left customs',
        'held at customs',
    ];
    return all.filter(i => !used.includes(i));
}

function ManifestEvents(props) {
    return (
        <div>
            <h5 className="mt-4">Events</h5>
            <Table>
                <thead>
                <tr>
                    <th>Description</th>
                    <th>Address</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                {
                    props.events.map((e, index) => {
                        return (
                            <tr key={index}>
                                <td>{e.description}</td>
                                <td>{e.city} {e.state} {e.zip}</td>
                                <td>{moment(e.event_date).tz('America/New_York').format('MMMM Do YYYY h:mm:ss a')}</td>
                            </tr>
                        );
                    })
                }
                </tbody>
            </Table>
        </div>
    )
}

function isDelivered(carrier, lastTrackingCode, lastTrackingDescription) {
    if (carrier === 'VIPPARCEL') {
        return lastTrackingCode === '01'
    }
    if (carrier === 'UPS') {
        return lastTrackingDescription === 'Delivered'
    }
    return false
}

class Package extends React.Component {
    constructor(props) {
        super(props);
        const d = props.data;
        this.state = {
            id: d.id,
            carrier: d.carrier,
            trackingNumber: d.tracking_number,
            hawb: d.hawb,
            receivedByVelox: d.received_by_velox,
            lastTrackingEventCode: d.last_tracking_event_code,
            lastTrackingEventDescription: d.last_tracking_event_description,
            description: d.description,
            adminHTSCode: d.admin_hts_code ? d.admin_hts_code : '',
            customsHTSCode: d.customs_hts_code,
            customsHTSCodeIsType86: d.customs_hts_code_is_type_86,
            customsHTSCodeRequiresCPSC: d.customs_hts_code_requires_cpsc,
            customsHTSCodeDescription: d.customs_hts_code_description,
            htsTooltip: d.hts_tooltip,

            clearedAtCustoms: props.clearedAtCustoms,
            error: '',
            isSubmitting: false,
            adminDescription: '',
            adminDescriptionErr: '',
        };
    }

    render() {
        const s = this.state;
        const delivered = isDelivered(s.carrier, s.lastTrackingEventCode, s.lastTrackingEventDescription);

        const htsReasons = [];
        if (!s.customsHTSCodeIsType86) htsReasons.push('Not type 86');
        if (s.customsHTSCodeRequiresCPSC) htsReasons.push('Needs CPSC');
        const isRed = htsReasons.length > 0;
        const provenance = s.adminHTSCode ? '' : s.htsTooltip;
        const htsTitle = [htsReasons.join('; '), provenance].filter(Boolean).join(' — ');

        return (
            <tr>
                <td>{this.props.number + 1}</td>
                <td>
                    <a href={"/packages/" + s.trackingNumber}>{s.trackingNumber} </a>
                    <br/>
                    {
                        s.receivedByVelox ?
                            <span className="text-success">{s.hawb}</span> :
                            s.hawb
                    }
                </td>
                <td>{
                    delivered ?
                        <span className="text-success">{s.lastTrackingEventDescription}</span> :
                        s.lastTrackingEventDescription
                }</td>
                <td>{s.description}</td>
                <td>
                    <Form onSubmit={this.handleSubmitDescription} id={"form-customs-description-" + s.id}>
                        <InputGroup>
                            <Form.Control
                                name="description"
                                value={s.adminDescription}
                                onChange={e => {
                                    this.setState({adminDescriptionErr: ''});
                                    this.setState({adminDescription: e.target.value});
                                }}
                                isInvalid={!!s.adminDescriptionErr}
                                disabled={s.clearedAtCustoms}
                                style={{width: "250px"}}
                            />
                            <Form.Control.Feedback type="invalid">
                                {this.state.adminDescriptionErr}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form>
                </td>
                <td>
                    <Button type="submit" disabled={this.state.isSubmitting || s.clearedAtCustoms}
                            className="btn-success" form={"form-customs-description-" + this.props.data.id}>+</Button>
                </td>
                <td>
                    <Form onSubmit={this.handleSubmitHTS} id={"form-" + s.id}>
                        <InputGroup>
                            <Form.Control
                                name="code"
                                value={s.adminHTSCode}
                                onChange={e => {
                                    this.setState({error: '', alert: ''});
                                    this.setState({adminHTSCode: e.target.value});
                                }}
                                isInvalid={!!this.state.error}
                                disabled={s.clearedAtCustoms}
                                style={{width: "180px"}}
                            />
                            <Form.Control.Feedback type="invalid">
                                {this.state.error}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form>
                </td>
                <td>
                    <Button type="submit" disabled={this.state.isSubmitting || s.clearedAtCustoms}
                            className="btn-success" form={"form-" + s.id}>+</Button>
                </td>
                <td>
                    <span className={isRed ? 'text-danger' : 'text-success'} title={htsTitle}>
                        {s.customsHTSCode}
                    </span>
                </td>
                <td>
                    {isRed &&
                        <span className="text-danger">{htsReasons.join(', ')}</span>}
                </td>
                <td>{s.customsHTSCodeDescription}</td>
            </tr>
        );
    }

    handleSubmitDescription = (e) => {
        e.preventDefault();
        this.setState({isSubmitting: true});
        JwtClient.put(`/api/v1/admin/packages/${this.props.data.id}/description`, {
            description: this.state.adminDescription.trim(),
        })
            .then(response => {
                if (response.status === 200) {
                    this.setState((prevState, prevProps) => {
                        return {
                            isSubmitting: false,
                            description: prevState.adminDescription,
                            adminDescription: '',
                        }
                    })
                }
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        adminDescriptionErr: 'failed: ' + error.response.status,
                        isSubmitting: false,
                    });
                } else {
                    this.setState({
                        adminDescriptionErr: JSON.stringify(error),
                        isSubmitting: false,
                    });
                }
            });
    }

    handleSubmitHTS = (e) => {
        e.preventDefault();
        const code = this.state.adminHTSCode.trim();

        if (code.length !== 10) {
            this.setState({error: 'must be 10 digits'});
            return
        }

        if (isNaN(code)) {
            this.setState({error: 'only numbers'});
            return
        }

        this.setState({isSubmitting: true});
        JwtClient.put(`/api/v1/admin/packages/${this.props.data.id}/admin-hts-code`, {
            admin_hts_code: code,
        })
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        isSubmitting: false,
                        customsHTSCode: response.data.customs_hts_code,
                        customsHTSCodeIsType86: response.data.customs_hts_code_is_type_86,
                        customsHTSCodeRequiresCPSC: response.data.customs_hts_code_requires_cpsc,
                        customsHTSCodeDescription: response.data.customs_hts_code_description,
                    });
                }
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        error: 'failed: ' + error.response.status,
                        isSubmitting: false,
                    });
                } else {
                    this.setState({
                        error: JSON.stringify(error),
                        isSubmitting: false,
                    });
                }
            });
    };
}

class Packages extends React.Component {
    constructor(props) {
        super(props);
        this.packagesRef = React.createRef();
        this.state = {
            currentPage: 1,
            pagesTotal: 0,
            packagesTotal: 0,
            pageSize: 0,
            packages: [],
            alert: '',
            loading: true,
            clearedAtCustoms: props.clearedAtCustoms,
        };
    }

    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }
        if (this.state.loading) {
            return (<div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <h5 ref={this.packagesRef} className="mt-4">Packages [{this.state.packagesTotal}]</h5>
                <Table>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th title="Green: received by velox">Track/HAWB</th>
                        <th title="Green: delivered">Event</th>
                        <th>Description</th>
                        <th colSpan={2}>Change Description</th>
                        <th colSpan={2}>Change HTS</th>
                        <th title="Green: type 86; Red: not type 86 or requires CPSC certification">HTS</th>
                        <th title="Reason HTS is red">HTS Reason</th>
                        <th>HTS Hint</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.packages.map((p, index) => {
                            return <Package
                                data={p}
                                key={index}
                                number={(this.state.currentPage - 1) * this.state.pageSize + index}
                                clearedAtCustoms={this.state.clearedAtCustoms}
                            />
                        })
                    }
                    </tbody>
                </Table>

                <ul className="pagination justify-content-center">
                    <li className={this.state.currentPage === 1 ? "page-item disabled" : "page-item"}>
                        <a className="page-link" href="#" onClick={(e) => {
                            e.preventDefault()
                            this.getPackages(this.state.currentPage - 1)
                        }}>
                            Previous
                        </a>
                    </li>
                    <li className="page-item active"><span className="page-link">{this.state.currentPage}</span>
                    </li>

                    <li className={this.state.currentPage === this.state.pagesTotal ? "page-item disabled" : "page-item"}>
                        <a className="page-link"
                           href="#" onClick={(e) => {
                            e.preventDefault()
                            this.getPackages(this.state.currentPage + 1)
                        }}>
                            Next
                        </a>
                    </li>
                </ul>
            </div>
        )
    }

    componentDidMount() {
        this.getPackages(1)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.currentPage !== this.state.currentPage) {
            this.packagesRef.current.scrollIntoView(true);
        }
    }

    getPackages = (page) => {
        this.setState({loading: true})
        JwtClient.get(`/api/v1/admin/manifests/${this.props.manifestId}/packages?page=${page}`)
            .then(response => {
                const data = response.data;
                this.setState({
                    packages: data.packages,
                    pagesTotal: data.pages_total,
                    packagesTotal: data.packages_total,
                    pageSize: data.page_size,
                });
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        Logout();
                    } else {
                        this.setState({alert: 'Error on fetching packages, status: ' + error.response.status});
                    }
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
            .finally(() => {
                this.setState({loading: false, currentPage: page})
            })
    }
}

function DT({children}) {
    return <dt className="col-md-3">{children}</dt>;
}

function DD({children}) {
    return <dd className="col-md-9">{children}</dd>;
}

class VeloxReferenceNumberForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            veloxRefNum: props.veloxRefNum ? props.veloxRefNum : '',
            manifestID: props.manifestID,
            submitErr: '',
        };
    }

    render() {
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <div className="form-row">
                            <div className="col-3">
                                <input
                                    placeholder="Velox Reference #"
                                    className={this.state.submitErr ? "form-control is-invalid" : "form-control"}
                                    value={this.state.veloxRefNum}
                                    onChange={e => {
                                        const v = e.currentTarget.value;
                                        this.setState({veloxRefNum: v});
                                    }}
                                />
                                <div className="invalid-feedback" data-testid="order-err">{this.state.submitErr}</div>
                            </div>
                            <div className="col-2">
                                <button type="submit" className="btn btn-primary"
                                        disabled={this.state.isSubmitting}>Submit
                                </button>
                            </div>
                            <div className="col-2 btn btn-light mr-2">
                                <a className="text-success"
                                   href={`https://import.veloxhub.us/api/v1/manifest/${this.state.manifestID}/billing?token=${localStorage.getItem('token')}`}>CLIENT</a>
                            </div>
                            <div className="col-4 btn btn-light">
                                <a className="text-danger"
                                   href={`https://import.veloxhub.us/api/v1/manifest/${this.state.manifestID}/billing?token=${localStorage.getItem('token')}&cost=true`}>COST</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({isSubmitting: true, submitErr: ''});
        fetch(`/api/v1/admin/manifests/${this.state.manifestID}/velox-reference-number`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            },
            body: JSON.stringify({
                'velox_reference_number': this.state.veloxRefNum,
            })
        })
            .then(response => {
                this.setState({isSubmitting: false});

                if (response.status === 200) {
                    this.setState({isSubmitting: false});
                } else if (response.status === 400) {
                    response.json().then(data => {
                        this.setState({isSubmitting: false, submitErr: 'bad request'});
                    })
                } else if (response.status === 401) {
                    this.setState({isSubmitting: false, submitErr: 'unauthorized'})
                } else {
                    this.setState({isSubmitting: false, submitErr: 'server error'})
                }
            })
    };
}


export default class Manifest extends Component {
    eventDateFormat = 'YYYY-MM-DD HH:mm';

    constructor(props) {
        super(props);
        this.state = {
            manifest: {},
            trackingEvents: [],
            alert: '',
        };
    }

    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }

        const m = this.state.manifest;
        if (!m.mawb) {
            return null
        }

        const availableDescriptions = getAvailableDescriptions(this.state.trackingEvents);
        return (
            <div>
                <Container>
                    <h4 className="mt-4">{FormatManifestNumber(m.manifestNumber, m.user)} MAWB: {m.mawb}</h4>
                    <dl className="row">
                        <DT>User</DT>
                        <DD>{m.user}</DD>
                        <DT>Airports</DT>
                        <DD>{m.originAirport} - {m.destinationAirport}</DD>
                        <DT>Departure</DT>
                        <DD>{moment(m.departureDate).format('MMMM Do YYYY')}</DD>
                        <DT>Global tracking</DT>
                        <DD>
                            <a target="_blank" rel="noopener noreferrer"
                               href={"http://parcelsapp.com/en/tracking/" + m.mawb}>Track</a>
                        </DD>
                        {m.broker &&
                            <DT>Broker</DT>
                        }
                        {m.broker &&
                            <DD>{m.broker} {m.ibcClearanceType}
                                <Button variant="danger" size="sm" className="ml-3"
                                        onClick={this.unsetBroker}>Unset</Button>
                            </DD>
                        }

                        <DT>Total delivery</DT>
                        <DD>{this.state.totalCarrierDeliveryCents / 100}$</DD>
                        <DT>Billing</DT>
                        {/*<DD><a href={`https://import.veloxhub.us/api/v1/manifest-billing-file/${m.id}?token=${localStorage.getItem('token')}`}>Download</a></DD>*/}
                        <DD><VeloxReferenceNumberForm veloxRefNum={this.state.veloxReferenceNumber} manifestID={m.id}/></DD>
                    </dl>

                    {!m.broker && <IBCCustomsClearanceForm manifestId={this.props.match.params.id}
                                                           setClearanceType={this.setClearanceType}/>}
                    {m.broker && !!availableDescriptions && !!availableDescriptions.includes('left customs') &&
                        <ManifestEventForm
                            manifestId={this.props.match.params.id}
                            destinationAirport={m.destinationAirport}
                            descriptions={availableDescriptions}
                            addEvent={this.addEvent}
                            setAlert={this.setAlert}
                        />
                    }

                    {this.state.trackingEvents.length > 0 && <ManifestEvents events={this.state.trackingEvents}/>}
                </Container>
                <div className="container-fluid">
                    <Packages manifestId={this.props.match.params.id} clearedAtCustoms={!!m.broker}/>
                </div>
            </div>
        )
    }

    componentDidMount() {
        JwtClient.get('/api/v1/admin/manifests/' + this.props.match.params.id)
            .then(response => {
                const data = response.data;
                const manifest = data.manifest;
                this.setState({
                    manifest: {
                        id: manifest.id,
                        manifestNumber: manifest.manifest_number,
                        mawb: manifest.mawb,
                        user: manifest.user_id,
                        originAirport: manifest.origin_iata_airport_code,
                        destinationAirport: manifest.destination_iata_airport_code,
                        broker: manifest.customs_clearance_broker,
                        ibcClearanceType: manifest.customs_clearance_ibc_type,
                        departureDate: manifest.departure_date,
                    },
                    trackingEvents: data.tracking_events ? data.tracking_events : [],
                    totalCarrierDeliveryCents: manifest.total_carrier_delivery_cents,
                    veloxReferenceNumber: manifest.velox_reference_number,
                });
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        Logout();
                    } else {
                        this.setState({alert: 'Error on fetching manifest, status: ' + error.response.status});
                    }
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
    }

    setAlert = (msg) => {
        this.setState({alert: msg});
    };

    addEvent = (event) => {
        this.setState((prevState) => ({trackingEvents: [...prevState.trackingEvents, event]}));
    };

    unsetBroker = () => {
        if (!window.confirm('Unset broker and clear IBC clearance? You can then resend.')) return;
        JwtClient.post(`/api/v1/admin/manifests/${this.props.match.params.id}/customs-clearance/ibc/unset`, {})
            .then(response => {
                if (response.status === 200) {
                    window.location.reload();
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    Logout();
                } else {
                    this.setState({
                        alert: error.response
                            ? 'Error unsetting broker, status: ' + error.response.status
                            : JSON.stringify(error)
                    });
                }
            });
    };

    setClearanceType = (clearanceType) => {
        this.setState((prevState) => ({
            manifest:
                {
                    ...prevState.manifest,
                    clearanceType: clearanceType,
                    broker: "IBC",
                }
        }))
    }
}


